import * as types from "./personalTrustpassActionTypes";
import * as apiUrls from "./personalTrustpassApiUrls";
import { isEmpty } from "lodash";
import Cookies from "universal-cookie";
import { startLoading, stopLoading } from "../shared/actions";

const cookies = new Cookies();

export function createPersonalTrustpass(userId, callbackFunction) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2CreateUserPersonalTrustpassUrl(userId), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({}),
    })
    .then(response => response.json())
    .then(json => {
      callbackFunction();
      dispatch({
        type: types.RECEIVE_PERSONAL_TRUSTPASS,
        payload: json,
      });
    });
  };
}

export function fetchPersonalTrustpasses(userId) {
  return (dispatch) => {
    dispatch(startLoading());
    return fetch(apiUrls.apiV2FetchUserPersonalTrustpassesUrl(userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      if (isEmpty(json[0])) dispatch(createPersonalTrustpass(userId, () => {}));
      else {
        dispatch({
          type: types.RECEIVE_PERSONAL_TRUSTPASS,
          payload: json[0],
        })
      }
      dispatch(stopLoading());
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch(stopLoading());
    });
  };
}

export function fetchPersonalTrustpass(userId, personalTrustpassId) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2FetchUserPersonalTrustpassUrl(userId, personalTrustpassId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: types.RECEIVE_PERSONAL_TRUSTPASS,
        payload: json,
      })
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function updatePersonalTrustpass(urlProps, body, onSuccess, onError) {
  return (dispatch) => {
    const { userId, personalTrustpassId } = urlProps;
    const apiUrl = apiUrls.apiV2UpdateUserPersonalTrustpassUrl;

    return fetch(apiUrl(userId, personalTrustpassId), {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({ personal_trustpass: body }),
    })
    .then(response => {
      response.json().then(json => {
        if (response.ok) {
          dispatch({
            type: types.RECEIVE_PERSONAL_TRUSTPASS,
            payload: json,
          });
          dispatch({
            type: types.UPDATE_PERSONAL_TRUSTPASS_INFO,
            payload: json,
          });
          onSuccess();
        } else {
          onError(json.errors);
        }
      })
    })
  };
}

export function submitPersonalTrustpass(userId, personalTrustpassId) {
  return (dispatch) => {
    const apiUrl = apiUrls.apiV2SubmitUserPersonalTrustpassUrl;

    return fetch(apiUrl(userId, personalTrustpassId), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => {
      response.json().then(json => {
        dispatch({
          type: types.RECEIVE_PERSONAL_TRUSTPASS,
          payload: json,
        });
        dispatch({
          type: 'PERSONAL_TRUSTPASS_STATUS_UPDATE',
          payload: 'under verification',
        });
      })
    })
  };
}



// WEBPACK FOOTER //
// ./src/features/trustpass/personalTrustpassActions.js